module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-he.9401e971.png";